import { NgxSpinnerService } from 'ngx-spinner';
import { Component, OnInit, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { BACKEND } from '../../../../config';
import { ApiService } from '../../../../services/api.service';
import {
  FormGroup
  , FormControl
  , Validators
  , AbstractControl
  , ValidationErrors
  , FormBuilder
  , NgForm
  , FormGroupDirective
  , FormArray
} from '@angular/forms';
import { reCaptchaSiteKey } from 'src/app/config';
import { FormValidatorService } from 'src/app/shared/form_Validation/form-validator.service';
@Component({
  selector: 'app-password-forgot',
  templateUrl: './password-forgot.component.html',
  styleUrls: ['./password-forgot.component.css']
})
export class PasswordForgotComponent implements OnInit {
  forgotPassword: FormGroup;
  siteKey = reCaptchaSiteKey;
  googleToken: string;
  title = '';
  msg: string;
  constructor(public dialogRef: MatDialogRef<any>,
    private formBuilder: FormBuilder,
    private _api: ApiService
    , @Inject(MAT_DIALOG_DATA) public data
    , private Formvalidator: FormValidatorService,
    private spinner: NgxSpinnerService
  ) {
    this.forgotPassword = this.formBuilder.group({
      user_email: new FormControl('', [Validators.required, Validators.email]),
      recaptcha: ['', Validators.required],

    });
  }

  ngOnInit() {
    this.title = this.data.title;
    this.msg = this.data.pwdresetMsg ? this.data.pwdresetMsg : '';
    if (this.data.email) {
      this.forgotPassword.patchValue({
        user_email: this.data.email
      });
    }

  }
  sendResetLink() {
    this.spinner.show();
    let apiURL = 'user/resetPassword';


    if (!this.forgotPassword.get('user_email').value) {
      this.Formvalidator.markFormGroupTouched(this.forgotPassword);
      this._api.openSnackBar('Enter a valid email', 'Error');
      return false;
    }

    if (!this.googleToken) {
      this.Formvalidator.markFormGroupTouched(this.forgotPassword);
      this._api.openSnackBar('Select captcha', 'Error');
      return false;
    }
    const data = {
      email: this.forgotPassword.get('user_email').value,
      captchaToken: this.googleToken
    };
    if (this.data.type === 'resend_email') {
      apiURL = 'user/resendEmail';
    }
    this._api.functionPOST(apiURL, data).subscribe((res) => {
      if (res['success']) {
        this.spinner.hide();
        this._api.openSnackBar(res['data'], '');
        this.dialogRef.close();
      }
    }, (err) => {
      this.spinner.hide();
      this._api.openSnackBar(err['error'], 'Error');
    }
    );
  }


  closeDialog() {
    this.dialogRef.close();
  }

  handleSuccess($event) {
    this.googleToken = $event;
  }

}
